import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChatIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M1 4.71387C1 3.21777 2.2334 2 3.75 2H16V5.96H14V4H3.75C3.33643 4 3 4.32032 3 4.71387V12H4.5V14H3L1 15.6953V4.71387Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 7.43994C21.7666 7.43994 23 8.65771 23 10.1538V22.0015L19.0776 19.4399H8.75C7.2334 19.4399 6 18.2222 6 16.7261V7.43994H20.25ZM8 16.7261C8 17.1196 8.33643 17.4399 8.75 17.4399H19.6724L21 18.3062V10.1538C21 9.76026 20.6636 9.43994 20.25 9.43994H8V16.7261Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M10.5 14.9399C11.3284 14.9399 12 14.2684 12 13.4399C12 12.6115 11.3284 11.9399 10.5 11.9399C9.67157 11.9399 9 12.6115 9 13.4399C9 14.2684 9.67157 14.9399 10.5 14.9399Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M14.5 14.9399C15.3284 14.9399 16 14.2684 16 13.4399C16 12.6115 15.3284 11.9399 14.5 11.9399C13.6716 11.9399 13 12.6115 13 13.4399C13 14.2684 13.6716 14.9399 14.5 14.9399Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M20 13.4399C20 14.2684 19.3284 14.9399 18.5 14.9399C17.6716 14.9399 17 14.2684 17 13.4399C17 12.6115 17.6716 11.9399 18.5 11.9399C19.3284 11.9399 20 12.6115 20 13.4399Z",
    fill: "currentColor"
  }));
}